/** @jsx jsx */

import React, { useCallback } from 'react';
import { jsx } from '@emotion/core';
import useReactRouter from 'use-react-router';
import useNavigationHelpers from 'hooks/useNavigationHelpers';
import useWorkflow from 'hooks/useWorkflow';
import { useTheme } from 'emotion-theming';
import { Theme } from 'features/Theme';
import Button from 'components/Button';

import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import { Box } from '@material-ui/core';
import useTranslate from 'hooks/useTranslate';

const EmbeddedBackButton: React.FC = () => {
  const { goBack } = useNavigationHelpers();
  const theme = useTheme<Theme>();
  const {
    location: { pathname },
  } = useReactRouter();
  const {
    steps,
    workflow: { paths },
  } = useWorkflow();
  const t = useTranslate();
  const handleClick = useCallback(() => {
    goBack();
  }, [goBack]);

  if (!theme.embedded || pathname === paths[steps[0]]) {
    return null;
  }

  return (
    <Box m={1}>
      <Button variant="text" onClick={handleClick}>
        <ChevronLeftIcon />
        {t('embeddedBackButton')}
      </Button>
    </Box>
  );
};

export default EmbeddedBackButton;
